import { useState, useEffect } from 'react';
import { doc, getDoc, collection, query, where, getDocs, limit } from 'firebase/firestore';
import { db } from '../config/firebase';
import { recipesIndex } from '../utils/algoliaConfig';

const useRecommendedRecipes = (userId) => {
    const [recommendations, setRecommendations] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!userId) return;
        const load = async () => {
            setLoading(true);
            try {
                const userSnap = await getDoc(doc(db, 'users', userId));
                const userData = userSnap.exists() ? userSnap.data() : {};
                const preferences = userData.tiposComidaPreferidos || [];
                const following   = userData.following || [];

                const seenIds = new Set();
                const results = [];

                const addUnique = (list) => {
                    list.forEach(r => {
                        const id = r.objectID || r.id;
                        if (id && !seenIds.has(id) && r.imagen?.trim()) {
                            seenIds.add(id);
                            results.push(r);
                        }
                    });
                };

                // ── P0: Recetas de usuarios publicadas en Firestore ──
                try {
                    const userSnap2 = await getDocs(query(
                        collection(db, 'recetas'),
                        where('fuente', 'in', ['usuario', 'CookyChat']),
                        where('privacidad', '==', 'publica'),
                        limit(30)
                    ));
                    addUnique(userSnap2.docs.map(d => ({ id: d.id, objectID: d.id, ...d.data() })));
                } catch { /* sin índice, continúa */ }

                // ── P1: Recetas de cuentas seguidas ──
                if (following.length > 0) {
                    try {
                        const snap = await getDocs(query(
                            collection(db, 'recetas'),
                            where('userId', 'in', following.slice(0, 10)),
                            limit(20)
                        ));
                        addUnique(snap.docs.map(d => ({ id: d.id, objectID: d.id, ...d.data() })));
                    } catch { /* continúa */ }
                }

                // ── P2: Preferencias del perfil vía Algolia ──
                for (const pref of preferences.slice(0, 3)) {
                    const { hits } = await recipesIndex.search(pref, { hitsPerPage: 12 });
                    addUnique(hits.filter(h => h.imagen));
                }

                // ── P3: Relleno vía Algolia ──
                if (results.length < 30) {
                    const { hits } = await recipesIndex.search('', { hitsPerPage: 60 });
                    addUnique(hits.filter(h => h.imagen));
                }

                setRecommendations(results.slice(0, 60));

            } catch (e) {
                console.error('[useRecommendedRecipes]', e);
            } finally {
                setLoading(false);
            }
        };
        load();
    }, [userId]);

    return { recommendations, loading };
};

export default useRecommendedRecipes;